import { IsNumber, IsOptional, Min } from "class-validator";

import { TransformToNum } from "./utils";

export class WithPagination {

  @IsOptional()
  @IsNumber()
  @Min(1)
  @TransformToNum()
  readonly take?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @TransformToNum()
  readonly skip?: number;

}
